import React from 'react'
import {
  IconCreditCard,
  IconFileText,
  IconMessage,
  IconPhoneCall,
  IconUserViewfinder,
} from '../../utils/icons'

interface IconProps {
  width: string
  height: string
  fill: string
}

export interface IInfoColumn {
  id: string
  title: string
  icon: React.FC<IconProps>
  description: React.ReactNode
}

export const infoColumns: IInfoColumn[] = [
  {
    id: '1',
    title: 'Основная информация',
    icon: IconUserViewfinder,
    description: 'Заполните обязательние поля, отмеченые звездочкой (<span class="required">*</span>).<br/> Банк, логин, пароль и ФИО являются обязательными',
  },
  {
    id: '2',
    title: 'Паспортные данные',
    icon: IconFileText,
    description: 'Укажите коректные паспортные данные<br/> Эти данные будут отображаться в профиле клиента',
  },
  {
    id: '3',
    title: 'Обратная связь',
    icon: IconPhoneCall,
    description: 'Укажите предпочтительный способ обратной связи<br/> Данные будут отображаться в нижней части шаблона сайта',
  },
  {
    id: '4',
    title: 'Настройки чата',
    icon: IconMessage,
    description: 'Настройте параметры сообщения<br/> Автоматическое открытие чата или текст по-умолчанию',
  },
  {
    id: '5',
    title: 'Баланс',
    icon: IconCreditCard,
    description: 'Установите общий баланс<br/> По-умолчанию будет суммироваться баланс в рублях по всем картам и счетам клиента',
  }
]